var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88574 15.4609C5.4209 15.4609 5.07227 15.2866 4.75684 14.8965L0.457031 9.60059C0.216309 9.31006 0.116699 9.03613 0.116699 8.74561C0.116699 8.08154 0.606445 7.6001 1.28711 7.6001C1.69385 7.6001 1.97607 7.74951 2.25 8.08984L5.85254 12.6553L12.8833 1.51562C13.1655 1.06738 13.4478 0.901367 13.9126 0.901367C14.585 0.901367 15.0664 1.37451 15.0664 2.03027C15.0664 2.2876 14.9917 2.55322 14.7925 2.85205L7.02295 14.8716C6.75732 15.27 6.37549 15.4609 5.88574 15.4609Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneIcon);
export default __webpack_public_path__ + "static/media/done-icon.988ebc4f20317672af028bdafb5b1d8c.svg";
export { ForwardRef as ReactComponent };